module.exports = __webpack_public_path__ + "static/media/fakeAvatar3.f0075ccd.svg";